export default __webpack_public_path__ + "static/media/1.467880ce.jpg";